import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export function useTrialBookings() {
    const { authorizedFetch } = useAuth();
    const [trials, setTrials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const load = useCallback(async () => {
        if (!authorizedFetch) return;
        setLoading(true);
        try {
            const res = await authorizedFetch(`${API_URL}/api/daycare/trials`);
            if (!res.ok) throw new Error(await res.text());
            setTrials(await res.json());
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [authorizedFetch]);

    useEffect(() => { load(); }, [load]);

    const createTrial = async (data) => {
        const res = await authorizedFetch(`${API_URL}/api/daycare/trials`, {
            method: 'POST',
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error(await res.text());
        const created = await res.json();
        setTrials(prev => [created, ...prev]);
        return created;
    };

    const updateTrial = async (id, data) => {
        const res = await authorizedFetch(`${API_URL}/api/daycare/trials/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error(await res.text());
        const updated = await res.json();
        setTrials(prev => prev.map(t => t._id === id ? updated : t));
        return updated;
    };

    const deleteTrial = async (id) => {
        const res = await authorizedFetch(`${API_URL}/api/daycare/trials/${id}`, { method: 'DELETE' });
        if (!res.ok) throw new Error(await res.text());
        setTrials(prev => prev.filter(t => t._id !== id));
    };

    return { trials, loading, error, createTrial, updateTrial, deleteTrial, reload: load };
}
